import { render, staticRenderFns } from "./ExamStructurePropertiesSave.vue?vue&type=template&id=1befec27&"
import script from "./ExamStructurePropertiesSave.vue?vue&type=script&lang=js&"
export * from "./ExamStructurePropertiesSave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports